// Statische Texte der Stellenangebote-Seite (Spec Abschnitt 7), eine Datei je App.
// Beschriftungen wörtlich von der Live-Seite übernommen (#15, #22).
export const LABELS = {
    // Titel im Browser-Tab und Hinweis fuer Links in neue Tabs (#178)
    pageTitle: 'Stellenangebote',
    opensNewTab: '(öffnet in neuem Tab)',
    searchLabel: 'Suchbegriff',
    searchPlaceholder: 'Beruf, Stadt, Branche, …',
    countNoun: 'Stellenangebote',
    countFound: 'gefunden:',
    // Seitenleiste (#223)
    pager: 'Seiten',
    pagerPage: 'Seite',
    pagerPrev: 'Zurück',
    pagerNext: 'Weiter',
    loadingJobs: 'Stellenangebote werden geladen …',
    loadingJob: 'Stellenangebot wird geladen …',
    error: 'Die Stellenangebote konnten nicht geladen werden.',
    empty: 'Zu dieser Auswahl gibt es zurzeit keine Anzeigen.',

    back: 'Alle Stellenangebote',
    jobsOfCompany: 'Anzeigen von',
    offerFrom: 'STELLENANGEBOT VON',
    publishedOn: 'Veröffentlicht am',
    download: 'Stellenbeschreibung herunterladen',
    print: 'Stellenbeschreibung drucken',
    companyWebsite: 'Zur Unternehmens-Website',
    contactHeading: 'Du hast noch Fragen oder benötigst weitere Informationen?',
    phone: 'Tel:',
    email: 'E-Mail:',
    applyLead: 'Um sich für diesen Job zu bewerben,',
    applyLink: 'bitte hier klicken.',
    moreFrom: 'Alle Stellenangebote von',
    socialHeading: 'Das Unternehmen im Netz',
    videoTitle: 'Video zur Stellenanzeige'
}

// Aussteller-Profilseite (#239).
export const EXHIBITOR = {
    banner: 'AUSSTELLER AUF DEN JOB4U-MESSEN',
    loading: 'Aussteller wird geladen …',
    notFound: 'Diesen Aussteller gibt es auf job4u nicht oder nicht mehr.',
    toEvents: 'Zu den Messen',
    internship: 'Praktikum möglich',
    events: 'Auf diesen Messen',
    professions: 'Berufe und Studiengänge',
    // Zwischenueberschriften der Berufe nach Art, in dieser Reihenfolge (#245);
    // ohne Art "Weitere Berufe".
    professionGroups: [
        { type: 'Ausbildung', title: 'Ausbildungsberufe' },
        { type: 'Duales Studium', title: 'Duale Studiengänge' },
        { type: 'Studium', title: 'Studiengänge' },
        { type: 'Freiwilligendienst', title: 'Freiwilligendienste' }
    ],
    otherProfessions: 'Weitere Berufe',
    internships: 'Praktika',
    internshipsIntro: 'Dieser Aussteller bietet auf den Messen Praktikumsplätze an.',
    jobs: 'Stellenangebote',
    contact: 'Kontakt'
}

export const BREADCRUMB = {
    start: 'Start',
    jobs: 'Stellenangebote'
}

// Netzwerke der Anzeige (jobs.social). Die Reihenfolge ist die Anzeigereihenfolge;
// ein weiteres Netz braucht nur einen Eintrag hier.
export const SOCIAL_NETWORKS = [
    { key: 'facebook', name: 'Facebook' },
    { key: 'instagram', name: 'Instagram' },
    { key: 'tiktok', name: 'TikTok' },
    { key: 'linkedin', name: 'LinkedIn' },
    { key: 'xing', name: 'Xing' }
]

// Reihenfolge der ersten vier Schalter wie auf der Live-Seite; Praktikum kam
// als Art der Stellenanzeige dazu und steht darum am Ende (#158).
export const JOB_TYPES = ['Studium', 'Ausbildung', 'Duales Studium', 'Freiwilligendienst', 'Praktikum']
